export default async function handleLeadTypeFilterChanges(eventValue, leadsAwaitingAction, teamInvestigatingLeads, teamClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter) {
    let awaitingAction = await handleFiltering(eventValue, leadsAwaitingAction, leadTierFilter, leadNewFilter, leadTagFilter);
    let investigating = await handleFiltering(eventValue, teamInvestigatingLeads, leadTierFilter, leadNewFilter, leadTagFilter);
    let closing = await handleFiltering(eventValue, teamClosingLeads, leadTierFilter, leadNewFilter, leadTagFilter);
    return {awaitingAction, investigating, closing}
  }

  let handleFiltering = async (eventValue, leads, leadTierFilter, leadNewFilter, leadTagFilter) => {
    let filteredLeads = []
    let filterType = true
    if (eventValue === 'All') {
      filterType = false
    } 
    for (let i = 0; i < leads.length; i++) {
      let pushLead = true
      if (filterType) {
        if (eventValue === 'renegotiation') {
          if (leads[i].targetOutcome !== 'renegotiation') {
            pushLead = false
          }
        } else {
          if (leads[i].targetOutcome !== 'refinance') {
            pushLead = false
          }
        }
      }
      if (pushLead) {
        if (leadNewFilter === 'true' && !leads[i].newLeadLabel) {
          pushLead = false
        } else if (leadTierFilter !== 'All') {
          if (leadTierFilter === 'Tier 1') {
            if (leads[i].tier !== 1) {
              pushLead = false
            }
          } else if (leadTierFilter === 'Tier 2') {
            if (leads[i].tier !== 2) {
              pushLead = false
            }
          } else {
            if (leads[i].tier !== 0) {
              pushLead = false
            }
          }
        } else if (leadTagFilter[0] !== 'All') {
          for (let j = 0; j < leadTagFilter.length; j++) {
            let matchingInvestigation = leads[i].tagIds.find(tag => tag === leadTagFilter[j])
            if (!matchingInvestigation) {
              pushLead = false
            }
          }
        }      
      }
      if (pushLead) {
        filteredLeads.push(leads[i])
      }
    }
  
    return filteredLeads
  }